import { defineStore } from "pinia";
import type { Customer, MemberPermission } from "@zhihaoscm/entity";
import { useUserStore } from "@/stores/user";

export enum AccountType {
    COMMON = 1, // 普通账号
    ROOT_ACCOUNT, // 主账号
    SUB_ACCOUNT // 子账号
}
const zhihaoWebAccountObj = JSON.parse(window.localStorage.getItem("zhihao-web-account") || "{}");
export const useAccountStore = defineStore("zhihao-web-account", {
    state: (): {
        accountType: number;
        actualAccount: Customer;
        actualMemberPermission: MemberPermission;
        proxyActualAccount: Customer;
        proxyMemberPermission: MemberPermission;
    } => ({
        accountType: zhihaoWebAccountObj?.accountType || (undefined as unknown as number),
        actualAccount: zhihaoWebAccountObj?.actualAccount || ({} as Customer),
        actualMemberPermission: zhihaoWebAccountObj?.actualMemberPermission || ({} as MemberPermission),
        proxyActualAccount: zhihaoWebAccountObj?.proxyActualAccount || ({} as Customer),
        proxyMemberPermission: zhihaoWebAccountObj?.proxyMemberPermission || ({} as MemberPermission)
    }),
    getters: {
        /**是否是普通账号 */
        isCommonAccount: state => {
            return state.accountType === AccountType.COMMON;
        },
        /**是否是管理员账号 */
        isRootAccount: state => {
            return state.accountType === AccountType.ROOT_ACCOUNT;
        },
        /**是否是子账号 */
        isSubAccount: state => {
            return state.accountType === AccountType.SUB_ACCOUNT;
        },
        /**账号类型文案 */
        accountTypeDesc: state => {
            if (state.accountType === AccountType.SUB_ACCOUNT) return "子账号";
            else if (state.accountType === AccountType.ROOT_ACCOUNT) return "主账号";
            else return "";
        }
    },
    actions: {
        setAccountType() {
            const userStore = useUserStore();
            const meVo: any = userStore.userInfo;
            let accountType = AccountType.COMMON;
            if (meVo.proxyAccount && meVo.proxyAccount.id !== meVo.customer.id) {
                // 如果代理账号信息存在 并且 代理账号客户id != 实际账号客户id
                accountType = AccountType.SUB_ACCOUNT;
            } else if (
                meVo.proxyAccount &&
                meVo.proxyAccount.id === meVo.customer.id &&
                meVo.customer.institutionName
            ) {
                // 如果代理账号信息不存在 并且 实际账号进行了组织机构认证 就为 主账号
                accountType = AccountType.ROOT_ACCOUNT;
            }
            this.accountType = accountType;
        },
        setActualAccount(account: Customer) {
            this.actualAccount = account;
        },
        setActualMemberPermission(memberPermission: MemberPermission) {
            this.actualMemberPermission = memberPermission;
        },
        setProxyAccount(account: Customer) {
            this.proxyActualAccount = account;
        },
        setProxyMemberPermission(memberPermission: MemberPermission) {
            this.proxyMemberPermission = memberPermission;
        }
    },
    persist: true
});
